import { render, staticRenderFns } from "./reclamosTerminados.vue?vue&type=template&id=6489bba0"
import script from "./reclamosTerminados.vue?vue&type=script&lang=js"
export * from "./reclamosTerminados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports